import { SxProps, Theme } from '@mui/material'

export const containerSx: SxProps<Theme> = {
  padding: {
    xs: '1rem 1.6rem 1.6rem',
    md: 0,
  },
  height: {
    md: '8.2rem',
  },
  alignItems: 'center',
  justifyContent: 'center',
  alignText: 'center',
  gap: '1.6rem',
  background: '#184A9B',
}

export const matchesCountNumberSx: SxProps<Theme> = {
  minWidth: {
    xs: '14.8rem',
  },
  height: '4.2rem',
  textAlign: 'center',
  color: (theme) => theme.palette.primary.contrastText,
  borderBottom: (theme) => `0.2rem solid ${theme.palette.primary.contrastText}`,
}

export const sidebarMatchesCountNumberSx: SxProps<Theme> = {
  ...matchesCountNumberSx,
  height: { xs: '6.2rem', md: '7.6rem' },
}

export const matchesCountTextSx: SxProps<Theme> = {
  textAlign: 'center',
  color: (theme) => theme.palette.primary.contrastText,
}

export const sidebarContainerSx: SxProps<Theme> = {
  padding: { xs: '2.4rem 4.8rem', md: '3.2rem 4.4rem', lg: '3.2rem 4.8rem' },
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: '3.2rem',
  color: (theme) => theme.palette.common.white,
  background: 'linear-gradient(180deg, #184A9B 0%, #03378B 100%)',
}

export const matchesCountHeaderSx: SxProps<Theme> = {
  alignItems: 'center',
}

export const matchesCountIconBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '12.4rem',
  height: '12.4rem',
}
